import { Icon } from "@/components/Icons/Icon";
import { useAuthStore } from "@roman/shared/store/auth.store";
import { pointsToMiraiMile } from "@roman/shared/utils/pointsToMiraiMile";
import { useNavigate } from "react-router-dom";

interface WithdrawalSuccessPageProps {
  id: string;
  totalConsumingPoints: number;
}

export const WithdrawalSuccessPage: React.FC<WithdrawalSuccessPageProps> = (props) => {
  const navigate = useNavigate();
  const fetchUser = useAuthStore((state) => state.fetchAndSetUser);
  const { id: orderId, totalConsumingPoints } = props;

  if (!orderId) {
    throw new Error("OrderId must be registered");
  }

  const handleButton = () => {
    fetchUser();
    navigate("/record");
  };

  return (
    <div className="bg-white min-w-full min-h-screen">
      <div className="py-10 px-5 flex flex-col items-start gap-[30px] w-full">
        <div className="flex flex-col items-center gap-3 w-full">
          <Icon src="/assets/check.svg" imageSize={{ width: "96", height: "96" }} />
          <p className="text-lg font-bold text-black">交換処理中です</p>
          <p className="text-[10px] font-normal text-gray">
            ギフトが送付されるまで3~4営業日いただいております。
            <br />
            交換履歴画面で、交換のステータスを確認することができます。
          </p>
        </div>
        <div className="flex flex-col items-start w-full gap-10">
          <div className="flex flex-col items-start gap-1 w-full">
            <p className="text-base text-black font-bold -tracking-[.01em]">消費マイル</p>
            <p className="text-base font-normal -tracking-[.01em] text-black pb-1 border-b border-[#ECECEC] border-solid w-full">
              {pointsToMiraiMile(totalConsumingPoints)}マイル
            </p>
          </div>
        </div>
        <div className="flex flex-col items-start w-full gap-10">
          <div className="flex flex-col items-start gap-1 w-full">
            <p className="text-base text-black font-bold -tracking-[.01em]">注文ID</p>
            <p className="text-base font-normal -tracking-[.01em] text-black pb-1 border-b border-[#ECECEC] border-solid w-full">
              {orderId}
            </p>
          </div>
        </div>

        <button
          className="flex items-center justify-center bg-primary text-white py-2.5 px-4 text-lg font-bold w-full rounded-md"
          type="button"
          onClick={handleButton}
        >
          交換画面のTOPへ
        </button>
      </div>
    </div>
  );
};
